const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {
  brand: 'Spire Labs',
  version: '2.2.1',
  year,
  productLink: 'http://www.spire-labs.com.uy',
  AutoCloseMobileNav: true, // true, false. Automatically close sidenav on route change (Mobile only)
  noCustomizer: false,
  color: {
    primary: '#108ee9',
    success: '#3dbd7d',
    info: '#01BCD4',
    infoAlt: '#948aec',
    warning: '#ffce3d',
    danger: '#f46e65',
    text: '#3D4051',
    gray: '#EDF0F1',
  },
  settings: {
    boxedLayout: false, // boolean: true, false
    fixedHeader: false, // boolean: true, false
    collapsedNav: false, // boolean: true, false
    offCanvasNav: false, // boolean: true, false
    sidebarWidth: 200, // number
    colorOption: '11', // string: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    theme: 'light', // (WIP) string: light, gray, dark
  },
};

module.exports = APPCONFIG;



// WEBPACK FOOTER //
// ./constants/Config.js